import React, {
	useEffect, useImperativeHandle, useRef, useState
} from 'react'
import { Form, Select } from 'antd'

// assets
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { map } from 'lodash'
import { ReactComponent as ChevronIcon } from '../assets/icons/BaseMiniIcons/chevron-down-3-icon.svg'
import { RootState } from '../reducers'
import { getUsers } from '../reducers/usersU/actions'
import { USER_ROLE } from '../utils/enums'

const { Item } = Form

const { Option } = Select

type Props = {
	onValueChange: (value: ISelectedUsersOption) => void,
	userValues: (number | null)[]
	queryParams?: any
	multiple?: boolean
	placeholder?: string
	ref?: React.Ref<any>
}

export interface ISelectedUsersOption {
	value: ISelectedUserOption[]
}

export interface ISelectedUserOption {
	value: number,
	label: string
}

const SelectUserField = (props: Props) => {
	const selectRef = useRef<any>()
	const {
		onValueChange, userValues, queryParams, multiple, placeholder, ref
	} = props
	const dispatch = useDispatch()
	const { t } = useTranslation('pages')

	const [userSelected, setUserSelected] = useState<any>([])

	useImperativeHandle(ref, () => ({
		focus: () => selectRef.current?.focus?.(),
		open: () => {
			selectRef.current?.blur?.()
			selectRef.current?.focus?.()
		}
	}))

	function onChange(value: string | string[], option: any) {
		if (!value || !option) {
			// Clear clicked
			onValueChange({ value: [] })
			setUserSelected([])
			return
		}

		let valuesArray

		if (Array.isArray(option)) {
			// multiple mode
			valuesArray = option.map((data: any) => ({
				value: data.value,
				label: data?.children
			}))
			setUserSelected(option.map((data: any) => data?.children))
		} else {
			// single mode
			valuesArray = [{
				value: option?.value,
				label: option?.children
			}]
			setUserSelected(option?.children ? [option?.children] : [])
		}

		onValueChange({ value: valuesArray })
	}

	const currentOrganization = useSelector((state: RootState) => state.profile.profile.data?.currentOrganization)

	useEffect(() => {
		dispatch(getUsers(
			1,
			100,
			{ role: [USER_ROLE.USER], ...queryParams }
		))
	}, [])

	useEffect(() => {
		setUserSelected(userValues)
	}, [userValues])

	const users = useSelector((state:RootState) => state.users.users.tableData)
		.map((user: any) => {
			const userName = user.lastName ? `${user.lastName} ${user.firstName}` : user.email
			return {
				value: user.id,
				label: userName
			}
		})

	const defaultPlaceholder = currentOrganization?.name
		? `Vyber zamestnanca ${currentOrganization.name}`
		: 'Vyber zamestnanca'

	return (
		<Item style={{ marginBottom: 0 }}>
			<Select
				ref={selectRef}
				onBlur={() => {}}
				className={'dropDown'}
				size={ 'middle'}
				onChange={onChange}
				mode={multiple ? 'multiple' : undefined}
				suffixIcon={<ChevronIcon width={20} height={20}/>}
				showSearch
				allowClear={true}
				value={userSelected}
				style={{ minWidth: 260 }}
				placeholder={placeholder || defaultPlaceholder}
				optionFilterProp="children"
			>
				{ map(users, (option) => (
					<Option
						key={ option.value }
						value={ option.value }
					>
						{ option.label }
					</Option>
				)) }
			</Select>
		</Item>
	)
}

// @ts-ignore
export default React.memo(SelectUserField)
